import { ICultureResources } from '../../models/resource.model';

export const thTH: ICultureResources = {
    cssVars: {
        fontFamilyTitle: 'Noto Sans Thai Variable',
        fontFamilyText: 'Noto Sans Thai Variable',
    },
    preloads: [
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/noto-sans-thai/files/noto-sans-thai-latin-wght-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
    ],
    styles: [
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/noto-sans-thai/index.css',
                rel: 'stylesheet',
            },
        },
    ],
};
